module.exports = require('./lib/react.js')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/react.js
// module id = ./node_modules/glamor/react.js
// module chunks = 1